import { defineComponent as _defineComponent } from 'vue'
import {
  computed, onMounted, ref, watch,
} from 'vue';
import appConfig from '@/appConfig';
import { SSpinner, SGlobalErrorDialog } from '@slg/web-customer-shared';
import TheHeader from '@/components/theHeader/TheHeader.vue';
import Footer from '@/components/footer/Footer.vue';
import SessionExpiredDialog from '@/components/common/SessionExpiredDialog.vue';
import CookieManagement from '@/components/cookie/CookieManagement.vue';
import {
  useStore, useRouteRef, useI18n, useVm,
} from '@/composables';


const __default__ = {
  name: 'App',
  metaInfo: {
    // todo add dynamic for each SPA page -> R3
    title: 'Flexibus',
  },
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const store = useStore();
const route = useRouteRef();
const { i18n } = useI18n();
const vm = useVm();

const isHeaderShown = ref(true);
const lastScrollPosition = ref(0);
const globalErrorDialog = ref<{ open?: Function } | null>(null);

const isGlobalLoading = computed(() => store.getters['common/isGlobalLoading']);
const getLocation = computed(() => store.getters['auth/getLocation']);
const getLabel = computed(() => store.getters['common/getLabel']);
const isCurrentPageCheckout = computed(() => route.value.name === 'Checkout');

async function checkLocation() {
  const location = localStorage.getItem('location');
  if (!location) {
    await store.dispatch('auth/setGeoData');
  }
}

async function checkAuth() {
  const token = localStorage.getItem('authToken');
  if (token) {
    try {
      await store.dispatch('auth/populateUserProfileInfo');
      store.commit('auth/setAuthToken', token);
    } catch (e) {
      store.commit('auth/clearAuthTokenAndProfileInfo');
    }
  }
}

async function initPlacesApi() {
  // eslint-disable-next-line no-undef
  const key = config.VUE_APP_GOOGLE_KEY || process.env.VUE_APP_GOOGLE_KEY;
  if (!document.querySelector('[data-name="googlePlaceApi"]')) {
    const placeApiScript = document.createElement('script');
    placeApiScript.src = `https://maps.googleapis.com/maps/api/js?key=${key}&libraries=places&language=${route.value.params.lang}`;
    placeApiScript.dataset.name = 'googlePlaceApi';
    document.head.appendChild(placeApiScript);
  }
}

function onScroll(e: Event) {
  const defaultScrollValue = 60;
  const target = e.target as HTMLElement;
  if (target.scrollTop > defaultScrollValue && lastScrollPosition.value < target.scrollTop) {
    isHeaderShown.value = false;
  }
  if (lastScrollPosition.value > target.scrollTop) {
    isHeaderShown.value = true;
  }
  lastScrollPosition.value = target.scrollTop;
}

watch(() => route.value.params.lang, (lang) => {
  const supported = appConfig.languages.includes(lang as string);
  i18n.locale = supported ? (lang as string) : appConfig.defaultLanguage;
}, { immediate: true });

async function createdInit() {
  await initPlacesApi();
  await checkAuth();
  await checkLocation();
}
createdInit();

onMounted(() => {
  (vm.$root as any).openGlobalErrorDialog = (payload: unknown) => globalErrorDialog.value?.open?.(payload);
  store.commit('common/setAppConfig', appConfig);
});

return { __sfc: true,store, route, i18n, vm, isHeaderShown, lastScrollPosition, globalErrorDialog, isGlobalLoading, getLocation, getLabel, isCurrentPageCheckout, checkLocation, checkAuth, initPlacesApi, onScroll, createdInit, SSpinner, SGlobalErrorDialog, TheHeader, Footer, SessionExpiredDialog, CookieManagement }
}

})